import RegisterForm from "@/model/Form/RegisterForm"
import { ref, Ref } from "vue"

const registerForm: Ref<RegisterForm | null> = ref(null)

export default registerForm
